// extracted by mini-css-extract-plugin
module.exports = {"AsideNavigation":"AsideNav_AsideNavigation__1-6vu","MainNavigation":"AsideNav_MainNavigation__eoxV2"};